import React from 'react';
import { Form } from 'react-bootstrap';
import { useField, useFormikContext } from 'formik';
import { ValueType } from 'react-select';

import { FieldLabel, FieldError } from '../../../common/';

import { MultiSuggestFieldBody } from './components';
import { TMultiSuggestFieldProps } from './MultiSuggestField.interface';

export const MultiSuggestField = (props: TMultiSuggestFieldProps): JSX.Element => {
  const { name, label = '', onChange } = props;
  const { setFieldValue } = useFormikContext();
  const [inputProps, { error }] = useField({ name });

  const onSelectChange = (chosenValue: ValueType<{ value: unknown }>) => {
    setFieldValue(name, chosenValue);
    if (onChange) {
      onChange(chosenValue);
    }
  };

  return (
    <Form.Group controlId={name}>
      <FieldLabel label={label} />
      <MultiSuggestFieldBody {...props} {...inputProps} onChange={onSelectChange} isValid={!error} />
      {error && <FieldError error={error} />}
    </Form.Group>
  );
};
